import { FormGroup } from '@angular/forms';

import { FieldValidationError } from '../../errors';

const SERVER_ERROR_KEY = 'server';

export function applyFieldErrors(
  form: FormGroup,
  error: FieldValidationError,
  messages?: Record<string, string>
): void {
  const fieldErrors = error.data?.fieldErrors ?? {};

  Object.entries(fieldErrors).forEach(([property, message]) => {
    const control = form.get(property);

    if (control) {
      control.setErrors({ ...control.errors, [SERVER_ERROR_KEY]: messages?.[property] ?? message });
      control.markAsTouched();
    }
  });
}

export function clearFieldErrors(form: FormGroup): void {
  Object.values(form.controls).forEach((control) => {
    if (!control.hasError(SERVER_ERROR_KEY)) {
      return;
    }

    const errors = { ...control.errors };
    delete errors[SERVER_ERROR_KEY];

    control.setErrors(Object.keys(errors).length > 0 ? errors : null);
  });
}
